import { useEffect, useRef } from "react";
import { useNotifications } from "./useNotifications";

export function useMarkNotificationReadByItemIdOnMount(itemId: unknown) {
  const { markNotificationAsReadByItemId, isLoading } = useNotifications();
  const hasTriggered = useRef(false);
  useEffect(() => {
    if (hasTriggered.current) {
      return;
    }
    if (typeof itemId === "string" && !isLoading) {
      (async () => {
        await markNotificationAsReadByItemId(itemId);
      })();
      hasTriggered.current = true;
    }
  }, [isLoading, itemId, markNotificationAsReadByItemId]);
}
